import React from 'react'
import { useParams } from 'react-router-dom'
import { useRedirectTo } from '@@partner:helpers/hooks/location'

import { Panel } from 'rsuite'
import ProductReviewForm from '@components/catalog/productReview/ProductReviewForm'

import { ROUTE_CATALOG_PRODUCT_REVIEWS } from '@@partner:config/routes'

export default function ProductReviewFormPage () {
  const { productReviewId, brandSlug } = useParams<any>()
  const redirectToCatalog = useRedirectTo(ROUTE_CATALOG_PRODUCT_REVIEWS, {
    brandSlug
  })

  return (
    <div className="ProductReviewFormPage">
      <h1 className="u-heading">
        {productReviewId ? 'Редактирование' : 'Добавление'}
      </h1>
      <Panel shaded>
        <ProductReviewForm
          productReviewId={productReviewId}
          onSaved={redirectToCatalog}
          brandSlug={brandSlug}
        />
      </Panel>
    </div>
  )
}
